import { STORAGE_KEY } from '@/constants';

interface ScrollHistory {
  /**
   * * {pathname}: {scrollTop}
   */
  [key: string]: number;
}

export const scrollHistoryTracker = () => {
  const getAll = () => {
    const scrollHistory = sessionStorage.getItem(STORAGE_KEY.SCROLL_HISTORY);

    if (!scrollHistory) {
      return {};
    }

    return JSON.parse(scrollHistory) as ScrollHistory;
  };

  const get = (pathname: string): number | undefined => {
    const scrollHistory = getAll();

    return scrollHistory[pathname];
  };

  const set = (pathname: string, scrollTop: number) => {
    const current = getAll();
    const newHistory = {
      ...current,
      [pathname]: scrollTop,
    } satisfies ScrollHistory;

    sessionStorage.setItem(
      STORAGE_KEY.SCROLL_HISTORY,
      JSON.stringify(newHistory),
    );
  };

  const remove = (pathname: string) => {
    const current = getAll();
    delete current[pathname];
    sessionStorage.setItem(STORAGE_KEY.SCROLL_HISTORY, JSON.stringify(current));
  };

  return {
    set,
    get,
    remove,
  };
};
